<template>
  <Info> Oh no, the page you're looking for can't be found! </Info>
</template>

<script>
export default {
  name: "NotFound",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
